import React, { useState } from 'react';
import { IconButton, makeStyles, Menu, MenuItem } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import PropTypes from 'prop-types';
import { S3_URL } from '../../api';
import { Link, useHistory } from 'react-router-dom';
import { resetBusinesses } from '../../actions/business';
import { resetAuth } from '../../actions/auth';
import { resetApp } from '../../actions/app';
import { useDispatch } from 'react-redux';
import {
  NotificationsNoneRounded as NotificationIcon,
  AccountCircle as AccountIcon
} from '@material-ui/icons'


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  iconButton: {
    fontSize: 28,
    color: '#1a1a1a'
  }
}));


function TopNav(props) {
  const { business } = props;
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const closeMenu = () => {
    setAnchorEl(null);
  }

  return (
    <div className={classes.root}>
      {business?.logo
        ? <Link to='/'>
            <img
              src={`${S3_URL}/businesses/${business.id}/${business.logo}`}
              alt='Logo'
              height={30}
            />
          </Link>
        : <Skeleton variant='text' width={120} height={60} />} {/* Logo */}

      <div>
        <IconButton className={classes.iconButton}>
          <NotificationIcon fontSize='inherit' />
        </IconButton>

        <IconButton
          className={classes.iconButton}
          onClick={openMenu}
        >
          <AccountIcon fontSize='inherit' />
        </IconButton>
      </div>

      <Menu
        id='account-menu'
        anchorEl={anchorEl}
        keepMounted
        open={anchorEl != null}
        onClose={closeMenu}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuItem
          onClick={() => {
            history.push('/account');
          }}
        >
          Account
        </MenuItem>

        <MenuItem
          onClick={() => {
            dispatch(resetBusinesses());
            dispatch(resetAuth());
            dispatch(resetApp());
            history.push('/');
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
}

TopNav.propTypes = {
  business: PropTypes.object
}


export default TopNav;
